<script>
import { deleteGroupOpinion } from '../../api/group-opinions';
import { deleteOpinion } from '../../api/opinions';

export default {
  name: 'CpSocialFeedOpinionPost',
  data() {
    return {
      showLikesModal: false,
      showDeleteModal: false,
      showLobbyDialog: false,
      comments_count: this.opinion.comments_count,
      likes_count: this.opinion.likes_count,
      liked: this.opinion.liked,
      loadingDelete: false,
      hash: '',
    };
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
    marginTop: require('../../directives/margins').marginTop,
    marginLeft: require('../../directives/margins').marginLeft,
    marginRight: require('../../directives/margins').marginRight,
  },
  components: {
    PersonIcon: require('../icons/person').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpDialog: require('../../dialog').default,
    CpButtonLink: require('../../button-link').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpButton: require('../../button').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    TrashIcon: require('../icons/trash-icon.vue').default,
    EditIcon: require('../icons/edit-icon.vue').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
    CpLobbyFlowDialog: require('../../dialogs/LobbyFlowDialog').default,
    LobbyActionButton: require('../actions/lobby-action-button').default,
  },
  props: {
    type: String,
    opinion: { type: Object, default: () => {} },
    createAlert: Function,
    reload: Function,
    isEditing: Boolean,
    edit: Function,
    loadingEdit: Boolean,
  },
  created() {
    const url = new URL(window.location.href);
    this.hash = url.hash;
  },
  methods: {
    handleLobbyDialog() {
      this.showLobbyDialog = !this.showLobbyDialog;
    },
    handleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal;
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      value ? (this.likes_count = this.likes_count + 1) : (this.likes_count = this.likes_count - 1);
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
    navigateTo(path) {
      window.location.href = path;
    },
    deleteOp(id) {
      this.loadingDelete = true;

      if (this.type === 'opinion') {
        deleteOpinion(id)
          .then(() => {
            this.createAlert({ message: 'The post has been successfully deleted', theme: 'success' });
            this.hash === '#post' ? this.navigateTo('/feed') : this.reload();
          })
          .catch(error => {
            if (error.response && error.response.data) {
              const { error: errorCode, messages } = error.response.data;

              if (errorCode === 'failed_to_find_opinion') {
                this.hash === '#post' ? this.navigateTo('/feed') : window.location.reload();
              } else {
                this.createAlert({ message: messages[0], theme: 'danger' });
              }
            }
            console.warn(error);
          })
          .finally(() => {
            this.loadingDelete = false;
            this.handleDeleteModal();
          });
      } else if (this.type === 'group-opinions') {
        deleteGroupOpinion(id, { group_owner_id: this.opinion?.group?.user_id })
          .then(() => {
            this.createAlert({
              message: 'The post has been successfully deleted',
              theme: 'success',
            });
            this.hash === '#post' ? this.navigateTo('/feed#groups') : this.reload();
          })
          .catch(error => {
            if (error.response && error.response.data) {
              const { error: errorCode, messages } = error.response.data;

              if (errorCode === 'failed_to_find_group_opinion') {
                this.hash === '#post' ? this.navigateTo('/feed#groups') : window.location.reload();
              } else {
                this.createAlert({ message: messages[0], theme: 'danger' });
              }
            }
            console.warn(error);
          })
          .finally(() => {
            this.loadingDelete = false;
            this.handleDeleteModal();
          });
      }
    },
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
    canEditPost() {
      return this.opinion.owner.id == this.$root?.authUser?.id;
    },
    canDeletePost() {
      return this.$root?.authUser?.is_admin || this.opinion.owner.id == this.$root?.authUser?.id || this.opinion?.group?.user_id == this.$root?.authUser?.id;
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper-social">
    <div style="margin-top: 10px !important">
      <CpShowInteractionsCount :type="type" :id="opinion.id" :likesCount="likes_count" :commentsCount="comments_count" :handleLikesModal="handleLikesModal" />
    </div>

    <div class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button :type="type" :id="opinion.id" :liked="liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button comment">
        <comment-action-button :type="type" :id="opinion.id" />
      </div>
      <div class="post-action-button share">
        <cp-social-share-dialog
          class="feed"
          :allow-share-feed="true"
          share-category="Opinion"
          :type="type"
          :post="opinion"
          :id="opinion.id"
          share-button-class="button--noborder"
          :url="opinion.permalink"
          title="Check out this post found on CrowdBlue's social feed!"
          :description="`Wanted to share this opinion I found on CrowdBlue, the Social Network for Politics.`"
          quote="Check out this post found on CrowdBlue's social feed!"
          hashtags="crowdBlue,politics,political crowdfunding"
          twitter-user="crowdblue"
        ></cp-social-share-dialog>
      </div>

      <!-- Edit post -->
      <div v-if="canEditPost" class="post-action-button delete">
        <cp-button @click="edit" noborder bold :loading="loadingEdit" :disabled="loadingEdit" style="margin-top: -3px; background-color: transparent;">
          <cp-base-svg-icon v-if="!isEditing" :width="20" :height="20" viewBox="0 0 17 20" icon-color="var(--primary-blue-400)" :stroke-color="'none'">
            <edit-icon />
          </cp-base-svg-icon>
          <i v-else class="fas fa-times-circle fa-1-5x primary-blue-400-color" v-margin-right="!$root.isMobile ? .2 : 0"></i>
          <span v-if="!$root.isMobile" class="body primary-blue-400-color">{{ isEditing ? 'Cancel' : 'Edit' }}</span>
        </cp-button>
      </div>

      <!-- Delete post -->
      <div v-if="canDeletePost" class="post-action-button delete">
        <cp-button @click="handleDeleteModal" noborder bold :disabled="loadingDelete || loadingEdit" style="margin-top: -3px; background-color: transparent;">
          <cp-base-svg-icon :width="20" :height="20" viewBox="0 0 17 20" icon-color="var(--primary-blue-400)" :stroke-color="'none'">
            <trash-icon />
          </cp-base-svg-icon>
          <span v-if="!$root.isMobile" class="body primary-blue-400-color">{{ authUser && authUser.is_admin ? 'Remove Post' : 'Delete' }}</span>
        </cp-button>
      </div>
      <div class="post-action-button like">
        <LobbyActionButton :handleLobbyDialog="handleLobbyDialog" title="Contact My Reps" />
      </div>
    </div>

    <!-- Comment input -->
    <cp-comments-post :id="opinion.id" :type="type" :setCount="setCommentsCount" />

    <!-- Modals -->
    <cp-dialog v-if="showLikesModal">
      <cp-likes-profiles :count-likes="likes_count" :id="parseInt(opinion.id)" :type="type" @close="handleLikesModal"></cp-likes-profiles>
    </cp-dialog>

    <cp-dialog v-if="showDeleteModal">
      <div style="margin: 25px" class="text-center">
        <p v-margin-bottom="1" class="subheadline1 black-color">Are you sure to delete this post?</p>
        <p class="body neutral4-color" v-margin-bottom="2">This action is permanent and it can’t be undone.</p>
        <div style="display: flex; align-items: center; justify-content: center">
          <cp-button block noborder :disabled="loadingDelete" @click="handleDeleteModal">
            <span>Cancel</span>
          </cp-button>
          <cp-button block primary @click="() => deleteOp(opinion.id)" :loading="loadingDelete" :disabled="loadingDelete" v-margin-left="1">
            <span>Delete</span>
          </cp-button>
        </div>
      </div>
    </cp-dialog>

    <CpLobbyFlowDialog
      v-if="showLobbyDialog"
      :showDialog="showLobbyDialog"
      type="none"
      customSubject="Concern over government spending"
      :newsArticle="opinion"
      :callback="handleLobbyDialog"
      shareMessageInComments
      :originalPostType="type"
      :originalPostId="opinion.id"
      @close="handleLobbyDialog"
    />
  </div>
</template>

<style scoped>
.button--darkgray-outline {
  transition: color 0.2s ease;
}
.social-feed-post-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 7px 0px;
}
.post-action-button.like,
.post-action-button.delete,
.post-action-button.share {
  width: auto;
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
}
.social-feed-post-wrapper-social {
  width: 100%;
  margin-top: 10px;
}
.search-results__tick_action {
  color: #cacaca;
  width: 50px;
}
a.profile-link {
  color: var(--color);
}
</style>
